import { themeColors } from "../../config";
import TouchableOpacity from "../../widgets/TouchableOpacity";
const SelectBar = ({ radius, length, index, selectIndex }) => {
  const dots = [];
  for (let i = 0; i < length; i++) {
    dots.push(
      <TouchableOpacity
        key={i}
        style={{
          width: radius * 2,
          height: radius * 2,
          borderRadius: radius,
          margin: radius,
          backgroundColor:
            index === i
              ? themeColors.transparentBlack
              : themeColors.transparentWhite,
        }}
        onClick={() => selectIndex(i)}
      ></TouchableOpacity>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        margin: 20,
      }}
    >
      {dots}
    </div>
  );
};
export default SelectBar;
